import React from "react";

const SkeletonCard = () => (
  <div className="eb-card eb-skeleton-card">
    <div className="eb-card-row">
      <div className="eb-card-left">
        <div className="eb-skeleton-block eb-skeleton-avatar" />
        <div className="eb-info">
          <div className="eb-skeleton-block eb-skeleton-name" />
          <div className="eb-skeleton-block eb-skeleton-ceo" />
          <div className="eb-progress-row">
            <div className="eb-skeleton-block eb-skeleton-progress" />
            <div className="eb-skeleton-block eb-skeleton-status" />
          </div>
        </div>
      </div>
      <div className="eb-card-actions">
        <div className="eb-skeleton-block eb-skeleton-btn" />
      </div>
    </div>
  </div>
);

// Loading placeholder shown while the client list is being fetched - mirrors
// StrategyCanvasSkeleton.js's real layout rather than a spinner.
const ExecutionBlueprintSkeleton = ({ count = 5 }) => (
  <div className="eb-list">
    {Array.from({ length: count }).map((_, index) => (
      <SkeletonCard key={index} />
    ))}
  </div>
);

export default ExecutionBlueprintSkeleton;
